

















import Vue from 'vue'
import ReviseCard from '../components/ReviseCard.vue'
import AddCard from '../components/AddCard.vue'
import Logout from '../components/Logout.vue'
import AppInfo from '../components/AppInfo.vue'
import GoToButton from '../components/Buttons/GoToButton.vue'

export default Vue.extend({
  name: 'App',
  components: {
    AddCard,
    ReviseCard,
    Logout,
    AppInfo,
    GoToButton
  },
  mounted () {
  },
  methods: {
  },
  computed: {
    hasCardsToRevise () {
      return !!localStorage['Default']
    }
  }
})
